import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { ControleEstoqueProdutoElement } from '../../interfaces/controle.estoque.produto';
import { NgxSpinnerService } from "ngx-spinner";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AngularFireDatabase } from "@angular/fire/database";
import { take } from 'rxjs/operators';
import { LogEstoqueProdutos } from 'src/app/interfaces/produtos.estoque';
import * as firebase from 'firebase';

@Component({
  selector: 'app-controle-estoque',
  templateUrl: './controle-estoque.component.html',
  styleUrls: ['./controle-estoque.component.scss', '../../styles/estilo.padrao.scss']
})
export class ControleEstoqueComponent implements OnInit {
  uid;
  consultaForm: FormGroup;

  produtosSource;
  bCaracterEspecial: boolean = false;

  displayedColumns: string[] = ['Codigo', 'Nome', 'Valor', 'QntEstoque', 'QuantidadeMinimaAlertaEstoque', 'AdcRemover', 'RemoverProduto'];
  produtos: Array<ControleEstoqueProdutoElement>;
  produtosLista: ControleEstoqueProdutoElement[] = [];
  auxObservableNomesProdutos;
  filtroTabela = "";
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private db: AngularFireDatabase,

  ) {
    this.uid = localStorage.getItem('uid');
    this.produtosSource = new MatTableDataSource([]);

  }

  ngOnInit(): void {
    this.consultaForm = this.formBuilder.group({
      nomeProduto: ['', null],
    });

  }

  onChangeNomeProduto(e) {
    if (e.length >= 4) {
      this.auxObservableNomesProdutos = this.usuarioService.getBuscaInicioNomeProduto(this.uid, e.toLowerCase()).subscribe(snap => {
        var dados;
        this.produtos = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();
          if (dados.NomeBusca.includes(e.toLowerCase())) {
            this.produtos.push({
              ID: item.key,
              CodigoProduto: dados.CodigoProduto,
              Nome: dados.Nome,
              ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
              QuantidadeEstoque: dados.QuantidadeEstoque,
              QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
              AdcRemover: 0
            });
          }
        });
      });
    }
  }

  adicionarProduto(prod) {
    const index = this.produtosLista.findIndex(x => x.ID === prod.ID);

    if (index === -1) {
      this.usuarioService.getEstoqueProduto(prod.ID).pipe(take(1)).subscribe(snap => {
        console.log(snap)
        if (snap)
          prod.QuantidadeEstoque = snap;
        else
          prod.QuantidadeEstoque = 0;

        this.produtosLista.push(prod);
        this.produtosSource = new MatTableDataSource(this.produtosLista);
      });

      this.consultaForm.get('nomeProduto').patchValue('');
    } else {
      this.toastr.warning("O produto já consta na tabela", 'Erro');
    }
  }

  removerProduto(prod) {
    const index = this.produtosLista.findIndex(x => x.ID === prod.ID);

    if (index !== -1) {
      let auxProdutos = this.produtosLista;
      auxProdutos.splice(index, 1);
      console.log(auxProdutos)
      this.produtosLista = auxProdutos;
      this.produtosSource = new MatTableDataSource(this.produtosLista);
    }
  }

  async salvar() {
    this.spinner.show('default');

    try {
      await Promise.all(this.produtosLista.map(async (value) => {
        if (!value.ID || value.QuantidadeMinimaAlertaEstoque === null || value.AdcRemover === null) {
          return;
        }

        let auxQuantidadeEstoque = 0;

        try {
          const transactionResp = await this.db
            .object(`Clientes/${this.uid}/EstoqueProdutos/${value.ID}/QuantidadeEstoque`)
            .query.ref.transaction((quantidadeEstoque) => {
              const estoqueAtual = quantidadeEstoque || 0;
              const novoEstoque = estoqueAtual + value.AdcRemover;

              return novoEstoque;
            });

          auxQuantidadeEstoque = transactionResp.snapshot.val();

          if (auxQuantidadeEstoque >= 0)
            await this.usuarioService.updateProduto(
              { QuantidadeEstoque: auxQuantidadeEstoque },
              value.ID
            );

          const map: LogEstoqueProdutos = {
            Tipo: value.AdcRemover >= 0 ? 'Entrada' : 'Saída',
            Pedido: 0,
            QuantidadeEstoqueAposOperacao: auxQuantidadeEstoque,
            AcrescimoDecrescimoControleGerenciar: value.AdcRemover,
            Timestamp: firebase.default.database.ServerValue.TIMESTAMP,
            Falha: ''
          };

          await this.usuarioService.setLogEstoqueProdutos(map, value.ID);

        } catch (e) {
          console.log(e);

          this.usuarioService.setLogEstoque(
            "Erro ao atualizar " + value.Nome + " " + value.ID + ". Erro: " + e,
            this.produtosLista,
            this.uid
          );

          const map: LogEstoqueProdutos = {
            Tipo: 'Falha alteração manual',
            Pedido: 0,
            QuantidadeEstoqueAposOperacao: auxQuantidadeEstoque,
            AcrescimoDecrescimoControleGerenciar: value.AdcRemover,
            Timestamp: firebase.default.database.ServerValue.TIMESTAMP,
            Falha: String(e)
          };

          await this.usuarioService.setLogEstoqueProdutos(map, value.ID);

          throw e;
        }
      }));

      this.toastr.success(
        'O estoque dos produtos foram alterados com sucesso!',
        'Status',
        { progressBar: true, positionClass: 'toast-top-center' }
      );

      this.usuarioService.setLogEstoque(
        "Alteração estoque produto",
        this.produtosLista,
        this.uid
      );

      setTimeout(() => {
        this.spinner.hide('default');
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/entrada-saida-estoque"])
        );
        this.toastr.clear();
      }, 800);

    } catch (e) {
      console.log(e);

      this.spinner.hide('default');

      this.usuarioService.setLogEstoque(
        "Erro ao atualizar estoque de produtos. Erro: " + e,
        this.produtosLista,
        this.uid
      );

      this.toastr.error(
        'Erro ao atualizar estoque de produtos! Atualize a página e verifique se o dado foi atualizado.',
        'Erro',
        { progressBar: true, positionClass: 'toast-top-center' }
      );
    }
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.produtosSource.filter = filterValue.trim().toLowerCase();

    if (this.produtosSource.paginator) {
      this.produtosSource.paginator.firstPage();
    }
  }

  limparCampos() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/controle-estoque"]));
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;

    if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 44 || k == 47) {
      return true;
    } else {
      this.bCaracterEspecial = true;
      return false;
    }
  }

  // convenience getter for easy access to form fields
  get g() { return this.consultaForm.controls; }
}
